// src/constants/rootCauseLabels.js — VIRAJ v9.5.1
// Canonical root cause labels for display.
// Import this wherever root_cause is shown to ensure consistency.

export const ROOT_CAUSE_LABELS = {
  CR_DROPPED:        "Conversion rate collapsed",
  SPEND_SPIKE:       "Spend increased sharply",
  SPEND_DROP:        "Spend dropped sharply",
  ATTRIBUTION_DELAY: "Attribution delayed",
  REVENUE_DROP:      "Revenue fell without clear cause",
  ROI_DEGRADED:      "Revenue efficiency degraded",
  MULTI_SIGNAL:      "Multiple signals deteriorated",
};
